import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function CashIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M28.1874 4H8.81196C7.26067 4 5.99939 5.2108 5.99939 6.7V17.5C5.99939 18.9892 7.26067 20.2 8.81196 20.2H28.1874C29.7387 20.2 31 18.9892 31 17.5V6.7C31 5.2108 29.7387 4 28.1874 4ZM12.562 9.4H10.687C10.1695 9.4 9.74948 8.9968 9.74948 8.5C9.74948 8.0032 10.1695 7.6 10.687 7.6H12.562C13.0796 7.6 13.4996 8.0032 13.4996 8.5C13.4996 8.9968 13.0796 9.4 12.562 9.4ZM18.4997 15.7C16.4321 15.7 14.7496 14.0848 14.7496 12.1C14.7496 10.1152 16.4321 8.5 18.4997 8.5C20.5672 8.5 22.2498 10.1152 22.2498 12.1C22.2498 14.0848 20.5672 15.7 18.4997 15.7ZM26.3124 16.6H24.4373C23.9198 16.6 23.4998 16.1968 23.4998 15.7C23.4998 15.2032 23.9198 14.8 24.4373 14.8H26.3124C26.8299 14.8 27.2499 15.2032 27.2499 15.7C27.2499 16.1968 26.8299 16.6 26.3124 16.6Z"
        fill="currentColor"
      />
      <path
        d="M26.3124 22H6.93691C5.38562 22 4.12434 20.7892 4.12434 19.3V8.7832L1.09177 19.636C0.701757 21.0652 1.59053 22.5472 3.08182 22.942L22.411 27.9112C22.651 27.9712 22.8923 28 23.1286 28C24.3748 28 25.5149 27.202 25.8424 26.002L26.9924 21.91C26.7736 21.964 26.5486 22 26.3124 22Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
